/**
 * Dynamic loader for third-party authentication SDKs.
 *
 * These scripts are NOT loaded in index.html — they are only fetched when a
 * user actually opens a login/register dialog that needs them. This saves
 * ~100KB+ of external requests on every public page load.
 */

const SCRIPT_CACHE = {};

const loadScript = (id, src) => {
  if (SCRIPT_CACHE[id]) return SCRIPT_CACHE[id];
  SCRIPT_CACHE[id] = new Promise((resolve, reject) => {
    // Already loaded?
    if (document.getElementById(id)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => {
      SCRIPT_CACHE[id] = null;
      reject(new Error(`Failed to load ${src}`));
    };
    document.head.appendChild(script);
  });
  return SCRIPT_CACHE[id];
};

export const loadGoogleSDK = () =>
  loadScript('google-gsi', 'https://accounts.google.com/gsi/client');

export const loadMicrosoftSDK = () =>
  loadScript('msal-js', 'https://alcdn.msauth.net/browser/msal-browser-3.10.0.min.js');

export const loadAppleSDK = () =>
  loadScript('apple-auth', 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js');

export default { loadGoogleSDK, loadMicrosoftSDK, loadAppleSDK };
